import axios from "axios";
import { environment } from "@/data/environment";

const actions = {
    async getTokenByCompany({ commit }, idCompany) {
        try {
            const endpoint = '/api/getTokenByCompany'
            const url = environment.HIOPOSWEBSERVICES + endpoint
            const { data } = await axios.post(
                url,
                {
                    idcompania: idCompany,
                }
            );

            commit("setToken", data.token);

            return data.token;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
};

const mutations = {
    setToken(state, token) {
        state.token = token;
    },
};

const state = {
    token: null,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};